module.exports = __webpack_public_path__ + "img/icon-2.1976ed51.png";